import { render, staticRenderFns } from "./ImgUploadBase64.vue?vue&type=template&id=9c0e3852&"
import script from "./ImgUploadBase64.vue?vue&type=script&lang=js&"
export * from "./ImgUploadBase64.vue?vue&type=script&lang=js&"
import style0 from "./ImgUploadBase64.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports